import { createFileRoute } from '@tanstack/react-router';
import { ProfitabilityPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/profitability')({
  component: ProfitabilityRoute,
});

function ProfitabilityRoute() {
  const { orgId } = Route.useParams();
  return <ProfitabilityPage orgId={orgId} />;
}
